<template>
  <div class="box" :class="[theme, this.isOpen?'':'collapsed-box', isSolid?'box-solid':'']">
    <div class="box-header" :class="(isBorder || isSolid)?'with-border':''">
      <slot name="icon-title"></slot>
      <h3 class="box-title">{{ title }}</h3>

      <div class="box-tools pull-right">
        <button v-if="btnIcon" type="button" class="btn btn-box-tool" :data-widget="widgetType">
          <i :class="btnIcon"></i>
        </button>
        <select class="form-control" v-if="list" v-model="selectedItem">
          <option value="" disabled="disabled">Select Dealer</option>
          <option v-for="(item,index) in list" :value="item.value">{{ item.title }}</option>
        </select>
      </div>
      <!-- /.box-tools -->
    </div>
    <!-- /.box-header -->
    <div class="box-body">
      <slot name="content"></slot>
    </div>
    <!-- /.box-body -->

    <div v-if="$slots.footer" class="box-footer">
      <slot name="footer"></slot>
    </div>

    <div v-if="this.isLoading" class="overlay">
      <i class="fa fa-refresh fa-spin"></i>
    </div>
  </div>
  <!-- /.box -->
</template>

<script>
  export default {
    name: 'va-box',
    data () {
      return {
        selectedItem: ''
      }
    },
    props: {
      widgetType: {
        type: String,
        default: 'collapse'
      },
      title: {
        type: String
      },
      list: {
        type: Array
      },
      imagesList: {
        type: Array
      },
      content: {
        type: String
      },
      theme: {
        type: String
      },
      isOpen: {
        type: Boolean,
        default: true
      },
      isLoading: {
        type: Boolean,
        default: false
      },
      isSolid: {
        type: Boolean,
        default: false
      },
      isBorder: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      btnIcon () {
        if (this.widgetType === 'collapse') {
          return this.isOpen ? 'fa fa-minus' : 'fa fa-plus'
        } else if (this.widgetType === 'remove') {
          return 'fa fa-times'
        }
        return ''
      }
    },
    watch: {
      selectedItem (val) {
        this.listItemChanged(val)
      }
    },
    created () {
      if (this.$root.isAdmin) {
        if (this.$root.dealers[0]) {
          this.selectedItem = this.$root.dealers[0].value
        }
      } else {
        if (this.$root.user && this.$root.user['.key']) {
          this.selectedItem = this.$root.user['.key']
        }
      }
    },
    methods: {
      listItemChanged (itemKey) {
        // console.log('listItemChanged >>> ' + itemKey)
        this.$emit('change', itemKey)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// VABox.vue?414b2d5c